'use strict';

/* CQ Article Service */

import TrackingUtils from "../../fsUtils/TrackingUtils";

angular.module('storyApp').factory('parselyService', function() {

    var parselyService = {
    	
    	doc: document,
        /* 
            param url - url to be tracked
            param idx - index number marking what '3 things' story number is to be tracked
            param utm_content - value to be passed to 'utm_content' (FSCOM-12270)
        */    		
    	passingUrl: function(url,idx, utm_content) {
    		var newUrlWithDomain = location.protocol + "//"+this.doc.domain + url;

    		if (typeof PARSELY !== "undefined" && typeof PARSELY.beacon === "object" && typeof PARSELY.beacon.trackPageView === 'function') {
    			                // add UTM campaign tracking params to url (FSCOM-12270)
                if (typeof idx !== 'undefined' && idx > 0) {
                    var utmObj = {
                        'utm_campaign': '3_things',
                        'utm_medium': 'fscom',
                        'utm_source' : '3things_' + idx
                    }
                    if(typeof utm_content !== 'undefined'){
                        utmObj['utm_content'] = utm_content;
                    }
                    newUrlWithDomain = TrackingUtils.addTrackingQuery(utmObj,newUrlWithDomain);
                }

    			PARSELY.beacon.trackPageView({
                    url:    newUrlWithDomain, // URL to be tracked
                    urlref: location.href,
                    js:     1 // flag indicating that this is a dynamic event, keep it "1"
                });
    		}
    	}	   
    }
    
    return parselyService;

});